export class CapacityModel {
  constructor(
    public linearMeters?: number,
    public squareMeters?: number,
    public weightTons?: number
  ) {}

  public fromJSON(json: any): CapacityModel {
    if (json) {
      this.linearMeters = Number(json.linearMeters ?? 0);
      this.squareMeters = Number(json.squareMeters ?? 0);
      this.weightTons = Number(json.weightTons ?? 0);
    }
    return this;
  }

  public toJSON() {
    return {
      linearMeters: this.linearMeters,
      squareMeters: this.squareMeters,
      weightTons: this.weightTons,
    };
  }
}
